export const FETCH_APPLICATION_OFFPLAN = 'FETCH_APPLICATION_OFFPLAN';
export const FETCH_APPLICATION_OFFPLAN_SUCCESS = 'FETCH_APPLICATION_OFFPLAN_SUCCESS';
export const FETCH_APPLICATION_OFFPLAN_ERROR = 'FETCH_APPLICATION_OFFPLAN_ERROR';

export const DOWNLOAD_DOCUMENT_OFFPLAN = 'DOWNLOAD_DOCUMENT_OFFPLAN';
export const DOWNLOAD_DOCUMENT_OFFPLAN_SUCCESS = 'DOWNLOAD_DOCUMENT_OFFPLAN_SUCCESS';
export const DOWNLOAD_DOCUMENT_OFFPLAN_ERROR = 'DOWNLOAD_DOCUMENT_OFFPLAN_ERROR';

export const OFFPLAN_CANCEL_APPLICATION = 'OFFPLAN_CANCEL_APPLICATION';
export const OFFPLAN_CANCEL_APPLICATION_SUCCESS = 'OFFPLAN_CANCEL_APPLICATION_SUCCESS';
export const OFFPLAN_CANCEL_APPLICATION_ERROR = 'OFFPLAN_CANCEL_APPLICATION_ERROR';

export const DOWNLOAD_OFFPLANE_CONTRACT_DOCUMENT = 'DOWNLOAD_OFFPLANE_CONTRACT_DOCUMENT';
export const DOWNLOAD_OFFPLANE_CONTRACT_DOCUMENT_SUCCESS = 'DOWNLOAD_OFFPLANE_CONTRACT_DOCUMENT_SUCCESS';
export const DOWNLOAD_OFFPLANE_CONTRACT_DOCUMENT_ERROR = 'DOWNLOAD_OFFPLANE_CONTRACT_DOCUMENT_ERROR';
